import { Box, Checkbox, Divider, FormControlLabel, Link, Stack } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import palette from '../../../theme/palette';
import TimeRow from './TimeRow';

export default function DayAndTime({ dayObj, onDaySelection, addSlot, removeSlot, updateSlot }) {
  const [daySelected, setSelectedDay] = useState(dayObj.selected);

  return (
    <>
      <Stack
        direction={{
          xs: 'column',
          sm: 'row'
        }}
        alignItems={{
          xs: 'flex-start',
          sm: dayObj.slots.length > 1 ? 'flex-start' : 'center'
        }}
        justifyContent="space-between"
        my={1}
      >
        <FormControlLabel
          sx={{ flex: 0.9 }}
          control={
            <Checkbox
              checked={daySelected}
              onChange={(e) => {
                setSelectedDay(e.target.checked);
                onDaySelection(dayObj._id);
              }}
            />
          }
          label={dayObj.day}
        />
        {daySelected ? (
          <Box
            sx={{
              flex: 2,
              ml: {
                xs: 4,
                sm: 0
              }
            }}
          >
            {dayObj.slots.map((slot, index) => (
              <TimeRow
                slot={slot}
                key={index}
                showAddBtn={dayObj.slots.length <= 1}
                removeBtn={index > 0}
                otherSelectedFromTime={dayObj.slots
                  .filter((sl) => sl._id !== slot._id)
                  .map((sl) => sl.from)}
                otherSelectedToTime={dayObj.slots
                  .filter((sl) => sl._id !== slot._id)
                  .map((sl) => sl.to)}
                addSlot={() => addSlot(dayObj._id)}
                updateSlot={(dateObj) => updateSlot(dayObj._id, slot._id, dateObj)}
                removeSlot={(slotId) => removeSlot(dayObj._id, slotId)}
              />
            ))}
          </Box>
        ) : (
          <Link
            sx={{
              flex: 2,
              textAlign: 'left',
              color: palette.grey[600],
              ml: {
                xs: 4,
                sm: 0
              }
            }}
            component="button"
            variant="body2"
            underline="hover"
            onClick={() => {
              setSelectedDay(true);
              onDaySelection(dayObj._id);
            }}
          >
            Select day and time slot
          </Link>
        )}
      </Stack>
      <Divider
        sx={{
          '&:last-child': {
            display: 'none'
          }
        }}
      />
    </>
  );
}

DayAndTime.propTypes = {
  dayObj: PropTypes.object,
  onDaySelection: PropTypes.func,
  addSlot: PropTypes.func,
  removeSlot: PropTypes.func,
  updateSlot: PropTypes.func
};
